export const subgraphBaseQuery = () => () => {
    throw new Error('All queries & mutations must use the `queryFn` definition syntax.');
};
//# sourceMappingURL=subgraphBaseQuery.js.map